import { t as translate } from 'i18next';
import * as yup from 'yup';

const BASE_URL_PATTERN = /^(https:\/\/)?[\p{L}\p{N}-]+(\.[\p{L}\p{N}-]+)+(:\d+)?\/?$/u;

export const baseUrlSchema = yup
  .string()
  .trim()
  .transform((value: string) =>
    typeof value === 'string' && value && !value.includes('://') ? `https://${value}` : value
  )
  .required(() => translate('common.required_field'))
  .matches(BASE_URL_PATTERN, () => translate('validation.invalid_url'));
